var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('Permissions',[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("platformDashboard"))+" ")]),_c('PlatformDashboardTabs')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }